import {Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import {STTableHeadTypography} from "@src/Components/Ui/STTableHeadTypography";
import {Values} from "Tools/Values";
import {STPaper} from "@src/Components/Ui/STPaperOverflow";
import React from "react";
import {IApplicationBase} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {AppTableItem} from "./AppTableItem/AppTableItem";

interface IProps {
    apps: IApplicationBase[];
    isEnabledApps: boolean;
    onEditButtonClick: (id: string) => void;
    onRemoveButtonClick: (id: string) => void;
}

const AppsTable = (props: IProps) => (
    <STPaper elevation={2}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <STTableHeadTypography>
                            {Values.getLocalizationValue("name")}
                        </STTableHeadTypography>
                    </TableCell>
                    <TableCell>
                        <STTableHeadTypography>
                            {Values.getLocalizationValue('description')}
                        </STTableHeadTypography>
                    </TableCell>
                    <TableCell>
                        <STTableHeadTypography>&nbsp;</STTableHeadTypography>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.apps.map((app: IApplicationBase) => (
                    <AppTableItem
                        key={app.clientId}
                        app={app}
                        isEnabled={props.isEnabledApps}
                        onEditButtonClick={() => props.onEditButtonClick(app.clientId)}
                        onRemoveButtonClick={() => props.onRemoveButtonClick(app.clientId)}
                    />
                ))}
            </TableBody>
        </Table>
    </STPaper>
)

export default AppsTable;